import { Pipe, PipeTransform } from '@angular/core';

import { RegularExpressions } from 'src/app/core/constants/regular-expressions';

@Pipe({
  name: 'reseller',
  standalone:true
})
export class ResellerPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if(!value) return "-";
    value=value.replace(RegularExpressions.symbols,'');
    value=value.replace( /,/g," <br>");
    return value;
  }

}
